import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with built-in show/hide toggle (eye icon).
 * Accepts all standard <input> props, plus an optional `testidEye`
 * for the toggle button.
 */
export default function PasswordInput({
  testidEye,
  className = "",
  ...inputProps
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        {...inputProps}
        type={visible ? "text" : "password"}
        className={`pr-11 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        data-testid={testidEye}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-900 p-0.5 rounded transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
